import {
  MERCHANT_SCHEME_ADD_REQUEST,
  MERCHANT_SCHEME_ADD_REQUEST_SUCCESS,
  MERCHANT_SCHEME_ADD_REQUEST_FAILURE,
  MERCHANT_SCHEME_FETCH_REQUEST,
  MERCHANT_SCHEME_FETCH_REQUEST_SUCCESS,
  MERCHANT_SCHEME_FETCH_REQUEST_FAILURE,
  MERCHANT_SCHEME_CLEAN_REQUEST,
  MERCHANT_SCHEME_TYPES_FETCH_REQUEST,
  MERCHANT_SCHEME_TYPES_FETCH_REQUEST_SUCCESS,
  MERCHANT_SCHEME_TYPES_FETCH_REQUEST_FAILURE,
  MERCHANT_SCHEME_TYPES_CLEAN_REQUEST,
} from '../constants/actionTypes';

const INITIAL_STATE = {
  payload: [],
  loading: false,
  errors: {},
  pagination: {
    current: 0,
    pageSize: 0,
    total: 0,
    totalPage: 0,
  },
};

const SCHEME_TYPE_INITIAL_STATE = {
  payload: [],
  loading: false,
  errors: {},
  pagination: {
    current: 0,
    pageSize: 0,
    total: 0,
    totalPage: 0,
  },
};

/**
 * A reducer takes two arguments, the current state and an action.
 */
const merchantSchemesReducer = (state, action) => {
  state = state || INITIAL_STATE;

  switch (action.type) {
    case MERCHANT_SCHEME_FETCH_REQUEST:
    case MERCHANT_SCHEME_ADD_REQUEST:
      return Object.assign({}, state, {
        loading: true,
      });

    case MERCHANT_SCHEME_FETCH_REQUEST_SUCCESS:
    case MERCHANT_SCHEME_ADD_REQUEST_SUCCESS:
      return Object.assign({}, state, {
        payload: action.data,
        loading: false,
        errors: {},
        pagination: {
          current: action.data.currentPage,
          pageSize: action.data.pageSize,
          total: action.data.totalRecord,
          totalPage: action.data.totalPage,
          showSizeChanger: true,
        },
      });

    case MERCHANT_SCHEME_FETCH_REQUEST_FAILURE:
    case MERCHANT_SCHEME_ADD_REQUEST_FAILURE:
      return Object.assign({}, state, {
        loading: false,
        errors: action.error,
      });

    case MERCHANT_SCHEME_CLEAN_REQUEST:
      return Object.assign({}, state, {
        payload: [],
        loading: false,
        errors: {},
        CRUDErrors: {},
        pagination: {
          current: 0,
          pageSize: 0,
          total: 0,
          totalPage: 0,
        },
      });

    default:
      return state;
  }
};

export const merchantSchemeListReducer = (state, action) => {
  state = state || SCHEME_TYPE_INITIAL_STATE;

  switch (action.type) {
    case MERCHANT_SCHEME_TYPES_FETCH_REQUEST:
      return Object.assign({}, state, {
        loading: true,
      });

    case MERCHANT_SCHEME_TYPES_FETCH_REQUEST_SUCCESS:
      return Object.assign({}, state, {
        payload: action.data,
        loading: false,
        errors: {},
        pagination: {
          current: action.data.currentPage,
          pageSize: action.data.pageSize,
          total: action.data.totalRecord,
          totalPage: action.data.totalPage,
          showSizeChanger: true,
        },
      });

    case MERCHANT_SCHEME_TYPES_FETCH_REQUEST_FAILURE:
      return Object.assign({}, state, {
        loading: false,
        errors: action.error,
      });

    case MERCHANT_SCHEME_TYPES_CLEAN_REQUEST:
      return Object.assign({}, state, {
        payload: [],
        loading: false,
        errors: {},
        pagination: {
          current: 0,
          pageSize: 0,
          total: 0,
          totalPage: 0,
        },
      });

    default:
      return state;
  }
};

export default merchantSchemesReducer;
